module.exports = __webpack_public_path__ + "static/media/logo192.c28b5334.png";